import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

interface ToolTipParams extends ICellRendererParams {
  lineBreak?: boolean;
  toolTipArray?: string[];
  toolTip?: string;
}

@Component({
    selector: 'app-tooltip-field',
    templateUrl: './tooltip-field.component.html',
    styleUrls: ['./tooltip-field.component.scss'],
    standalone: false
})
export class TooltipFieldComponent implements ICellRendererAngularComp {

  public params: ToolTipParams;
  public data: any;
  public toolTip: string;

  constructor() { }

  agInit(params: ToolTipParams): void {
    this.params = params;
    if (params.lineBreak == true) {  // NOSONAR
      this.toolTip = params.toolTipArray.join('\n');
    } else if (params.lineBreak == false) {  // NOSONAR
      this.toolTip = params.toolTip;
    } else {
      this.toolTip = params.value;
    }
  }

  refresh(params: ToolTipParams): boolean {
    this.params = params;
    return true;
  }

}
